import { render, staticRenderFns } from "./userProfileForm.vue?vue&type=template&id=511261d2"
import script from "./userProfileForm.vue?vue&type=script&lang=js"
export * from "./userProfileForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports